import api from "@/libs/axios";
import { QueryConfig } from "@/libs/query";
import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { QUERY_KEY } from "@/pages/taskpane/shared/constants/queryKey";
import { ColleagueEntity } from "./entities/colleagueEntity";

type PayLoadType = {
    pageSize?: number;
    nextIndex?: number;
    requestId: string;
    organizer: string;
    startDate: string;
    endDate: string;
    timeZoneStandardName: string;
};

const findRecentColleague = async (payload: PayLoadType) => {
    const { data } = await api.post(apiEnum.findRecentColleague , payload);
    return {
        isLastPage: data?.data?.isLastPage || false,
        nextIndex: data?.data?.nextIndex || 0,
        recents: (data?.data?.recents || []).map((item: any) => new ColleagueEntity(item)),
    };
};

export const options = (payload: PayLoadType) => infiniteQueryOptions({
    queryKey: [
        QUERY_KEY.FIND_RECENT_COLLEAGUE,
        {
            requestId: payload.requestId || '',
            organizer: payload.organizer || '',
            startDate: payload.startDate || '',
            endDate: payload.endDate || '',
            timeZoneStandardName: payload.timeZoneStandardName || '',
            pageSize: payload.pageSize || 10,
            nextIndex: payload.nextIndex || 0,
        }
    ],
    queryFn: ({ pageParam }) => {
        return findRecentColleague({ ...payload, nextIndex: pageParam });
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.isLastPage) {
            return undefined;
        }
        return allPages[allPages.length - 1]?.nextIndex || 0;
    },
})

type FindRecentColleagueType = {
    queryConfig?: QueryConfig<typeof options>;
    payload: PayLoadType;
    enabled?: boolean;
};

export const useFindRecentColleague = ({ queryConfig, payload, enabled = true }: FindRecentColleagueType) => {
    const query = useInfiniteQuery({
        ...options(payload),
        ...queryConfig,
        enabled: enabled,
    });
    return query;
};
